module.exports = __webpack_public_path__ + "static/media/logo.cdbe51aa.png";